import styled from "styled-components";
import { Icon } from "ui/styled";

export const DrawerBackdrop = styled.button.attrs({
    type: "button",
})`
    position: fixed;
    inset: 0;
    border: 0;
    background: ${({ theme }) => theme.palette.colors.backdrop};
    backdrop-filter: blur(4px);
    z-index: 120;
    padding: 0;
    cursor: pointer;
`;

export const DrawerPanel = styled.aside.attrs({
    className: 'menu-contant',
})`
    position: fixed;
    inset: 0 auto 0 0;
    width: min(338px, calc(100vw - 24px));
    background:
        linear-gradient(
            180deg,
            ${({ theme }) => theme.palette.colors.backgroundStrong} 0%,
            ${({ theme }) => theme.palette.colors.background} 100%
        );
    border-right: 1px solid ${({ theme }) => theme.palette.colors.border};
    z-index: 121;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export const DrawerHeader = styled.div`
    position: sticky;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 20px 18px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.border};
    background: ${({ theme }) => theme.palette.colors.backgroundStrong};
    backdrop-filter: blur(12px);
`;

export const DrawerBrand = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const DrawerBrandTitle = styled.div`
    font-family: Inter, sans-serif;
    font-size: 21px;
    font-weight: 700;
    line-height: 1;
    color: ${({ theme }) => theme.palette.colors.text};

    span {
        color: ${({ theme }) => theme.palette.colors.primary};
    }
`;

export const DrawerBrandCaption = styled.div`
    font-family: Inter, sans-serif;
    font-size: 13px;
    line-height: 1.4;
    color: ${({ theme }) => theme.palette.colors.subdued};
    letter-spacing: 0.06em;
    text-transform: uppercase;
`;

export const DrawerClose = styled.button.attrs({
    type: "button",
})`
    width: 40px;
    height: 40px;
    border-radius: 999px;
    border: 1px solid ${({ theme }) => theme.palette.colors.border};
    background: ${({ theme }) => theme.palette.colors.buttonGhost};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    transition:
        background 0.2s ease,
        transform 0.2s ease,
        border-color 0.2s ease;

    &:hover {
        background: ${({ theme }) => theme.palette.colors.surfaceSoft};
        border-color: ${({ theme }) => theme.palette.colors.primary};
        transform: translateY(-1px);
    }
`;

export const DrawerScroll = styled.div`
    flex: 1;
    overflow: auto;
    padding: 14px 14px 26px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    &::-webkit-scrollbar {
        width: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.palette.colors.border};
        border-radius: 999px;
    }
`;

export const DrawerProfileCard = styled.div`
    display: none;
    flex-direction: column;
    gap: 4px;
    padding: 16px;
    border: 1px solid ${({ theme }) => theme.palette.colors.border};
    border-radius: 18px;
    background: ${({ theme }) => theme.palette.colors.surfaceSoft};

    @media (max-width: 991px) {
        display: flex;
    }
`;

export const DrawerProfileName = styled.div`
    font-family: Gilroy, sans-serif;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.35;
    color: ${({ theme }) => theme.palette.colors.text};
`;

export const DrawerProfileMeta = styled.div`
    font-family: Lato, sans-serif;
    font-size: 13px;
    line-height: 1.5;
    color: ${({ theme }) => theme.palette.colors.subdued};
    text-transform: uppercase;
    letter-spacing: 0.05em;
`;

export const DrawerUtilityLabel = styled.div`
    display: none;
    padding: 4px 6px 2px;
    font-family: Poppins, sans-serif;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.4;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.palette.colors.subdued};

    @media (max-width: 991px) {
        display: block;
    }
`;

export const DrawerMobileOnlyGroup = styled.div`
    display: none;
    flex-direction: column;
    gap: 4px;

    @media (max-width: 991px) {
        display: flex;
    }
`;

export const DrawerSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6x;
    margin-top: ${({ separator }) => separator ? '18px' : '0'};
    padding-top: ${({ separator }) => separator ? '18px' : '0'};
    border-top: ${({ separator, theme }) => separator ? `1px solid ${theme.palette.colors.border}` : '0'};
    ${p => p.mobile ? `
            display: none;
        flex-direction: column;
        gap: 4px;

    @media (max-width: 991px) {
        display: flex;
    }
        ` : ``};
`;

export const DrawerItemButton = styled.button.attrs({
    type: "button",
})`
    width: 100%;
    border: 1px solid transparent;
    border-radius: 16px;
    padding: 12px 14px;
    
    background: ${({ active, theme }) => active ? theme.palette.sideMenu.main : 'transparent'};
    color: ${({ theme }) => theme.palette.sideMenu.contrastText};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    cursor: pointer;
    text-align: left;
    transition:
        background 0.24s ease,
        border-color 0.24s ease,
        transform 0.24s ease,
        box-shadow 0.24s ease;

    &:hover {
        background: ${({ active, theme }) => active
        ? `linear-gradient(135deg, ${theme.palette.colors.primary} 0%, ${theme.palette.primary.main} 100%)`
        : theme.palette.colors.surfaceSoft};
        transform: translateY(-1px);
    }

    ${({ active, theme }) => active ? `
        box-shadow: 0 16px 30px ${theme.palette.colors.shadow};
    ` : ``}
`;

export const DrawerItemMeta = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
`;

export const DrawerItemIcon = styled(Icon)`
    width: 24px;
    height: 24px;
`;

export const DrawerChevronIcon = styled(Icon)`
    width: 16px;
    margin: 0;
    transform: rotate(${({ expanded }) => expanded ? '180deg' : '0deg'});
    transition:
        transform 0.24s ease,
        opacity 0.24s ease;
`;

export const DrawerItemTitle = styled.div`
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: ${({ active }) => active ? 600 : 500};
    line-height: 1.45;
    color: ${({ active, theme }) => active ? theme.palette.sideMenu.contrastText : theme.palette.colors.muted};
    min-width: 0;
`;

export const DrawerChildren = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 6px 0 2px 18px;
`;

export const DrawerChildRow = styled.div`
    display: flex;
    align-items: stretch;
    gap: 4px;
`;

export const DrawerChildButton = styled.button.attrs({
    type: "button",
})`
    width: 100%;
    min-width: 0;
    border: 1px solid transparent;
    background: transparent;
    color: ${({ theme }) => theme.palette.colors.muted};
    padding: 8px 12px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    cursor: pointer;
    text-align: left;
    transition:
        background 0.2s ease,
        border-color 0.2s ease,
        transform 0.2s ease;

    &:hover {
        background: ${({ theme }) => theme.palette.colors.surfaceSoft};
        transform: translateX(2px);
    }

    ${({ active, theme }) => active ? `
        background: ${theme.palette.colors.surfaceSoft};
        border-color: ${theme.palette.colors.border};
        color: ${theme.palette.colors.text};
    ` : ``}
`;

export const DrawerChildToggle = styled.button.attrs({
    type: "button",
})`
    width: 38px;
    flex: 0 0 38px;
    border: 1px solid transparent;
    background: transparent;
    color: ${({ theme }) => theme.palette.colors.muted};
    padding: 0;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition:
        background 0.2s ease,
        border-color 0.2s ease,
        transform 0.2s ease;

    &:hover {
        background: ${({ theme }) => theme.palette.colors.surfaceSoft};
        transform: translateX(2px);
    }

    ${({ active, theme }) => active ? `
        background: ${theme.palette.colors.surfaceSoft};
        border-color: ${theme.palette.colors.border};
        color: ${theme.palette.colors.text};
    ` : ``}
`;

export const DrawerChildTitle = styled.div`
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: ${({ active }) => active ? 600 : 500};
    line-height: 1.45;
`;

export const DrawerSubChildren = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 2px 0 8px 14px;
`;

export const DrawerSubChildButton = styled.button.attrs({
    type: "button",
})`
    width: 100%;
    border: 1px solid transparent;
    background: transparent;
    color: ${({ theme }) => theme.palette.colors.subdued};
    padding: 8px 12px;
    border-radius: 10px;
    cursor: pointer;
    text-align: left;
    font-family: Inter, sans-serif;
    font-size: 13px;
    line-height: 1.45;
    font-weight: ${({ active }) => active ? 600 : 500};
    transition:
        background 0.2s ease,
        border-color 0.2s ease,
        transform 0.2s ease;

    &:hover {
        background: ${({ theme }) => theme.palette.colors.buttonGhost};
        transform: translateX(2px);
    }

    ${({ active, theme }) => active ? `
        background: ${theme.palette.colors.buttonGhost};
        border-color: ${theme.palette.colors.border};
        color: ${theme.palette.colors.text};
    ` : ``}
`;
